import React from 'react'
import OrdersContainer from 'containers/panel/customer/orders-container'

const OrdersPage = () => {
  return (
    <OrdersContainer/>
  )
}

export default OrdersPage